export default "__VITE_ASSET__CqJ8zYqd__"